import { render, staticRenderFns } from "./PrivacyProtection.vue?vue&type=template&id=860a4834&scoped=true&"
import script from "./PrivacyProtection.vue?vue&type=script&lang=js&"
export * from "./PrivacyProtection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860a4834",
  null
  
)

export default component.exports